import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, style, ...props }, ref) => {
  return (
    <textarea
      style={{ color: '#000000', backgroundColor: 'white', ...style }}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border-2 border-gray-300 px-3 py-2 text-base shadow-sm placeholder:text-gray-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-charcoal focus-visible:border-charcoal disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
